import { Modal, ModalProps } from './Modal';
import styles from './AddCategoryModal.module.scss';
import { Input } from '../input';
import { useRef, useState } from 'react';
import { Button } from '../button';
import { Dropdown } from '../dropdown';
import { app } from 'application';
import { type DropdownOption } from '../dropdown/Dropdown';
import { observer } from 'mobx-react-lite';

function AddCategoryModal(props: Omit<ModalProps, 'children'>): React.ReactElement {
  const { isOpen, onClose } = props;

  const [selectedDropdownCategory, setSelectedDropdownCategory] = useState<DropdownOption | null>(
    null
  );

  const mainCategoriesDropdownOptions: DropdownOption[] =
    app().categoriesStore.categories?.map(cat => ({
      label: cat.name,
      value: cat.id,
    })) || [];

  const _categoryName = useRef<string>('');

  const handleChangeCategoryName = (e: React.ChangeEvent<HTMLInputElement>) => {
    _categoryName.current = e.target.value;
  };

  const handleCloseModal = () => {
    onClose();
    _categoryName.current = '';
  };

  const handleAddCategory = async () => {
    if (!selectedDropdownCategory) {
      return;
    }

    if (_categoryName.current === '') {
      return;
    }

    await app().categoriesStore.createSubCategory({
      name: _categoryName.current,
      parent_id: selectedDropdownCategory?.value || '',
    });

    onClose();
  };

  const handleChangeCategoryParent = (value: string) => {
    setSelectedDropdownCategory(
      mainCategoriesDropdownOptions.find(cat => cat.value === value) || null
    );
  };

  return (
    <Modal isOpen={isOpen} onClose={handleCloseModal}>
      <div className={styles.modalContent}>
        <span className={styles.modalTitle}>Add New Category</span>

        <div className={styles.modalForm}>
          <Input
            label="Category Name"
            type="text"
            id="categoryName"
            placeholder="Category Name"
            onChange={handleChangeCategoryName}
          />

          <Dropdown
            placeholder="Select Parent Category"
            options={mainCategoriesDropdownOptions}
            value={selectedDropdownCategory?.value || ''}
            onChange={handleChangeCategoryParent}
          />
        </div>

        <Button
          isLoading={app().categoriesStore.isLoading}
          onClick={handleAddCategory}
          theme="Primary"
        >
          Add Category
        </Button>
      </div>
    </Modal>
  );
}

const AddCategoryModalWithObserver = observer(AddCategoryModal);

export { AddCategoryModalWithObserver as AddCategoryModal };
